(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34601],{

/***/ 28319:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/payment",
      function () {
        return __webpack_require__(42779);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SEO = function(param) {
    var url = param.url, title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "aiso, 인공지능, 인공지능 서비스, AI, machine learning"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url ? url : "https://aiso.ai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://aiso.ai/images/header/aiso_logo.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 89518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PageTokenCheck; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var function_LogOut__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39222);




/* 회원 비회원 token 값 체크 */ var PageTokenCheck = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(settings, router) {
        var tokenValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            if (tokenValue === "" || tokenValue === null) {
                settings.login = false;
                settings.email = "";
                settings.name = "";
                settings.photo = "";
                settings.uid = "";
                // window.localStorage.removeItem("aisoToken");
                router.push("/user/market");
                ;
            } else {
                /* 만료된 토큰인지 체크해야함 */ // const tokenParseValue = jwt.verify(tokenValue, process.env.SECRET_CODE);
                jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch", function(error, decoded) {
                    ;
                    if (error) {
                        /* 만료된 토큰임. token 삭제하기 */ // window.localStorage.removeItem("aisoToken");
                        (0,function_LogOut__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(settings);
                        router.push("/user/market");
                    } else {
                        var email = decoded.email, name = decoded.name, uid = decoded.uid;
                        settings.login = true;
                        settings.email = email;
                        settings.name = name;
                        settings.uid = uid;
                        var setTokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign({
                            email: email,
                            name: name,
                            uid: uid
                        }, "sdkjkdlsAESRcdslkch", {
                            expiresIn: "1d"
                        });
                        window.localStorage.setItem("aisoToken", setTokenValue);
                        if (router && router.asPath === "/") {
                            router.push("/user/market");
                        } else {
                            router.push(router.asPath);
                        }
                    }
                });
            }
            return [
                2
            ];
        });
    });
    return function PageTokenCheck(settings, router) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 42779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98105);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89518);
/* harmony import */ var components_SEO__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68590);
/** @format */ 








var Payment = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__/* .observer */ .Pi)(function(param) {
    var headUrl = param.headUrl, headTitle = param.headTitle, headDesc = param.headDesc;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    /* 로그인 체크 : url 이동 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_5__/* .PageTokenCheck */ .C)(settings, router);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SEO__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                url: headUrl,
                title: headTitle,
                desc: headDesc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col page-content w-full pt-12 pb-36 items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "font-bold mb-2",
                        children: "크레딧 충전/현황"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-gray mb-4",
                        children: "크레딧 충전 및 현황 페이지 준비중입니다."
                    })
                ]
            })
        ]
    });
});
Payment.getInitialProps = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
    var headTitle, headDesc, headUrl, _tmp;
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
        headTitle = "AISO PAYMENT";
        headDesc = "크레딧을 충전하여 앱을 사용하세요.";
        headUrl = "https://aiso.ai/user/payment";
        _tmp = {};
        return [
            2,
            (_tmp.headUrl = headUrl, _tmp.headTitle = headTitle, _tmp.headDesc = headDesc, _tmp)
        ];
    });
});
/* harmony default export */ __webpack_exports__["default"] = (Payment);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,92888,40179], function() { return __webpack_exec__(28319); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);